import { supabase } from "./client";
import { getCurrentEmpresaId } from "./auth-utils";

export interface ContaCategoria {
  id?: string;
  empresa_id?: string;
  nome: string;
  tipo?: "pagar" | "receber";
  created_at?: string;
  updated_at?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const contasCategoriasTable = () => supabase.from("contas_categorias" as any);

export async function listarContasCategorias(tipo: ContaCategoria["tipo"] = "pagar"): Promise<ContaCategoria[]> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return [];
    }

    const { data, error } = await contasCategoriasTable()
      .select("*")
      .eq("empresa_id", empresaId)
      .eq("tipo", tipo)
      .order("nome", { ascending: true });

    if (error) {
      console.error("Erro ao listar categorias de contas:", error);
      return [];
    }

    return (data || []) as unknown as ContaCategoria[];
  } catch (error) {
    console.error("Erro ao listar categorias de contas:", error);
    return [];
  }
}

export async function criarContaCategoria(
  categoria: Omit<ContaCategoria, "id" | "created_at" | "updated_at" | "empresa_id">
): Promise<{ ok: boolean; data?: ContaCategoria; error?: string }> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return { ok: false, error: "Usuário não tem empresa associada" };
    }

    const { data, error } = await contasCategoriasTable()
      .insert({
        ...categoria,
        empresa_id: empresaId,
        tipo: categoria.tipo || "pagar",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single();

    if (error) {
      console.error("Erro ao criar categoria de contas:", error);
      return { ok: false, error: error.message };
    }

    return { ok: true, data: data as unknown as ContaCategoria };
  } catch (error: unknown) {
    console.error("Erro ao criar categoria de contas:", error);
    const message = error instanceof Error ? error.message : "Erro ao criar categoria";
    return { ok: false, error: message };
  }
}

export async function deletarContaCategoria(id: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return { ok: false, error: "Usuário não tem empresa associada" };
    }

    const { error } = await contasCategoriasTable()
      .delete()
      .eq("id", id)
      .eq("empresa_id", empresaId);

    if (error) {
      console.error("Erro ao deletar categoria de contas:", error);
      return { ok: false, error: error.message };
    }

    return { ok: true };
  } catch (error: unknown) {
    console.error("Erro ao deletar categoria de contas:", error);
    const message = error instanceof Error ? error.message : "Erro ao deletar categoria";
    return { ok: false, error: message };
  }
}
